import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { AppDispatch, RootState } from "./Store";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useAppDispatch: () => any = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
